<div class="loading-shade" *ngIf="loadingService.isLoading">
  <mat-spinner class="loading-spinner"></mat-spinner>
</div>
